/** FR ↔ EN route pairs for language switcher and hreflang — auto-synced from pageRegistry */

export const localePairs = [
  {
    "fr": "/",
    "en": "/en"
  },
  {
    "fr": "/a-propos-agence-web-sherbrooke",
    "en": "/en/about"
  },
  {
    "fr": "/contact-agence-web-sherbrooke",
    "en": "/en/contact"
  },
  {
    "fr": "/portfolio-realisations-web",
    "en": "/en/portfolio"
  },
  {
    "fr": "/soumission-projet-web-gratuit",
    "en": "/en/free-quote"
  },
  {
    "fr": "/services",
    "en": "/en/services"
  },
  {
    "fr": "/faq",
    "en": "/en/faq"
  },
  {
    "fr": "/plan-du-site",
    "en": "/en/sitemap"
  },
  {
    "fr": "/newsletter",
    "en": "/en/newsletter"
  },
  {
    "fr": "/newsletter/unsubscribe",
    "en": "/en/newsletter/unsubscribe"
  },
  {
    "fr": "/services/conception-site-web-sherbrooke",
    "en": "/en/services/web-design"
  },
  {
    "fr": "/services/boutique-en-ligne-ecommerce",
    "en": "/en/services/ecommerce"
  },
  {
    "fr": "/services/developpement-saas-sur-mesure",
    "en": "/en/services/custom-saas"
  },
  {
    "fr": "/services/marketing-crm-automation",
    "en": "/en/services/marketing-crm"
  },
  {
    "fr": "/services/support-informatique-microsoft365-google",
    "en": "/en/services/it-cloud-support"
  },
  {
    "fr": "/services/photographie-video-corporative",
    "en": "/en/services/photography-video"
  },
  {
    "fr": "/services/publicite-google-ads-facebook",
    "en": "/en/services/google-ads"
  },
  {
    "fr": "/services/design-logo-entreprise",
    "en": "/en/services/logo-design"
  },
  {
    "fr": "/services/identite-visuelle-branding",
    "en": "/en/services/branding"
  },
  {
    "fr": "/services/crunkycat-media-visuels",
    "en": "/en/services/crunkycat-media"
  },
  {
    "fr": "/services/courriels-professionnels",
    "en": "/en/services/professional-email"
  },
  {
    "fr": "/services/hebergement-domaines",
    "en": "/en/services/hosting-domains"
  },
  {
    "fr": "/services/cartes-affaires",
    "en": "/en/services/business-cards"
  },
  {
    "fr": "/services/stockage-cloud",
    "en": "/en/services/cloud-storage"
  },
  {
    "fr": "/services/chatbots-messagerie",
    "en": "/en/services/chatbots"
  },
  {
    "fr": "/services/integration-ia-travail",
    "en": "/en/services/ai-integration"
  },
  {
    "fr": "/services/signature-electronique",
    "en": "/en/services/e-signature"
  },
  {
    "fr": "/services/sauvegarde-donnees",
    "en": "/en/services/data-backup"
  },
  {
    "fr": "/services/conseils-affaires",
    "en": "/en/services/business-consulting"
  },
  {
    "fr": "/services/creation-contenu-web",
    "en": "/en/services/web-content"
  },
  {
    "fr": "/services/photographie-domicile",
    "en": "/en/services/home-photography"
  },
  {
    "fr": "/services/boutiques-en-ligne-shopify",
    "en": "/en/services/shopify-stores"
  },
  {
    "fr": "/Tiguidou-web-Partenaire-Shopify-vente-enligne",
    "en": "/en/shopify-partner"
  },
  {
    "fr": "/aica",
    "en": "/en/aica"
  },
  {
    "fr": "/aica/demo-chat-intelligence-artificielle",
    "en": "/en/aica/demo"
  },
  {
    "fr": "/aica/solutions-ia-entreprise",
    "en": "/en/aica/business-solutions"
  },
  {
    "fr": "/aica/creation-chatbot-sur-mesure",
    "en": "/en/aica/custom-chatbot"
  },
  {
    "fr": "/politique-confidentialite",
    "en": "/en/privacy-policy"
  },
  {
    "fr": "/politique-cookies",
    "en": "/en/cookie-policy"
  },
  {
    "fr": "/conditions-utilisation",
    "en": "/en/terms-of-use"
  },
  {
    "fr": "/conditions-vente",
    "en": "/en/terms-of-sale"
  },
  {
    "fr": "/services/creation-web",
    "en": "/en/web-design"
  }
];

/** Paths with no EN equivalent — keep FR URL when locale is EN. */
const FR_ONLY_PREFIXES = ['/blogue'];

/** Legacy FR paths that map to a paired route root. */
const PATH_ALIASES = {
  '/services/aica': '/aica',
  '/services/en-ca/aica': '/aica',
};

function normalizePath(pathname) {
  const stripped = pathname.replace(/\/$/, '') || '/';
  return PATH_ALIASES[stripped] || stripped;
}

function joinPath(base, suffix) {
  if (!suffix) return base || '/';
  if (base === '/') return suffix;
  return base + suffix;
}

/** Longest-prefix match for FR or EN route bases. */
function findLocaleMatch(pathname) {
  const normalized = normalizePath(pathname);
  let best = null;
  let bestLen = -1;

  for (const pair of localePairs) {
    for (const side of [
      { lang: 'fr', base: pair.fr },
      { lang: 'en', base: pair.en },
    ]) {
      const { lang, base } = side;
      const matches =
        normalized === base ||
        (base !== '/' && normalized.startsWith(`${base}/`));
      if (matches && base.length > bestLen) {
        bestLen = base.length;
        const suffix = normalized === base ? '' : normalized.slice(base.length);
        best = { pair, lang, base, suffix };
      }
    }
  }
  return best;
}

export function getAlternateLocalePath(pathname) {
  const match = findLocaleMatch(pathname);
  if (!match) {
    const normalized = normalizePath(pathname);
    return normalized.startsWith('/en') ? '/' : '/en';
  }
  const { pair, lang, suffix } = match;
  if (lang === 'en') {
    return joinPath(pair.fr, suffix);
  }
  return joinPath(pair.en, suffix);
}

export function isEnglishPath(pathname) {
  return pathname === '/en' || pathname.startsWith('/en/');
}

export function getLocalizedPath(frPath, lang) {
  if (lang === 'fr') return frPath;
  const normalized = normalizePath(frPath.replace(/\/$/, '') || '/');
  if (FR_ONLY_PREFIXES.some((p) => normalized === p || normalized.startsWith(`${p}/`))) {
    return frPath;
  }
  const match = findLocaleMatch(normalized);
  if (!match) {
    return normalized === '/' ? '/en' : `/en${normalized}`;
  }
  return joinPath(match.pair.en, match.suffix);
}
